module.exports = __webpack_public_path__ + "img/index3.7b4d02de.png";